import _ from 'lodash';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { appUserLevels, gEnums } from '../../../global/enums/globalEnums';
import { GolfParentContext } from '../cnr/contexts/GolfParentContext';
import { uniqueKey } from '../../../global/common/keys';
import { Header, Icon, Label, Segment, Sidebar } from 'semantic-ui-react';
import DataSidebar from '../../../global/components/swipers/DataSidebar';
import AppForm from '../../../global/components/forms/appForms/AppForm';
import { settingsHelpers } from '../../../global/viewSettings/helpers/settingsHelpers';
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares';
import Wrapper, { wrapperTypes } from 'global/wrappers/Wrapper';
import { useColors } from 'global/cnr/contexts/useHelpers/useColors';

export const scorecardTypes = {
  scoring: 'scoring',
  normal: 'normal'
}

const Scorecard = (props) => {

  const { golfCourse: golfCourse_direct, scorecardType, handleAmmendScorecard } = props ?? {}

  const { getSplitColorStyles } = useColors()

  // golfParentContext 
  const golfParentContext = useContext(GolfParentContext)
  const { golfParent_contexts } = golfParentContext ?? {}
  const { states, fns } = golfParent_contexts ?? {}
  const { golfTournament_state } = states ?? {}
  const { appUser_fns } = fns ?? {}

  // parentContext   
  const allowMods = appUser_fns.validateAccess_item(appUserLevels.superAdmin, true)

  // golfParentContext   
  const { golfCourse } = golfTournament_state ?? {}

  const _golfCourse = golfCourse_direct ? golfCourse_direct : golfCourse

  const [selectedGolfCourse, setSelectedGolfCourse] = useState()
  const [selectedHole, setSelectedHole] = useState()
  const [selectedTeeBox, setSelectedTeeBox] = useState()
  const [holePrizes, setHolePrizes] = useState({ closestToPin: [], longestDrive: [] })

  const { holes, teeBoxes } = selectedGolfCourse ?? {}

  const _teeBoxes = useMemo(() => {
    if (teeBoxes) {
      _.forEach(teeBoxes, (tb, tbKey) => {
        tb.name = tbKey
      })
      return teeBoxes
    }
  }, [teeBoxes])

  const teeboxDistance = useMemo(() => {
    if (selectedTeeBox) {
      let dist = 0
      _.forEach(holes, hole => {
        dist += hole?.[selectedTeeBox?.name]
      })
      return dist
    }
  }, [selectedTeeBox, holes])

  useEffect(() => {
    if (_golfCourse) {
      setSelectedGolfCourse(_golfCourse)
      handleAmmendScorecard && handleAmmendScorecard(_golfCourse)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [_golfCourse]);

  const handleHoleNumber = (holeProp, holeNumber) => setSelectedHole({ holeProp, holeNumber })
  const handleCloseHoleEdit = () => setSelectedHole()

  const handleUpdateHoleData = (data) => {
    const _selectedGolfCourse = { ...selectedGolfCourse }
    const { holes } = _selectedGolfCourse ?? {}
    const { holeNumber } = selectedHole ?? {}
    let _hole = holes[holeNumber]
    _hole = { ..._hole, ...data }
    _selectedGolfCourse.holes[holeNumber] = _hole
    setSelectedGolfCourse(_selectedGolfCourse)
    handleAmmendScorecard && handleAmmendScorecard(_golfCourse)
    setSelectedHole()
  }

  const handleHolePrizes = (holeNumber, prize) => {
    const _holePrizes = { ...holePrizes }
    if (_holePrizes[prize].includes(holeNumber)) {
      const index = _holePrizes[prize].indexOf(holeNumber);
      if (index > -1) { _holePrizes[prize].splice(index, 1); }
    } else {
      _holePrizes[prize].push(holeNumber)
    }
    setHolePrizes(_holePrizes)
  }

  const holeDivs = (s, e, divs, r, holeProp, cn, isHoleNumber) => {
    divs.push(<div key={uniqueKey(holeProp, r, 'ttl')} className={'sct'} >{_.startCase(holeProp)}</div>)
    for (var holeNumber = s; holeNumber <= e; ++holeNumber) {
      const hn = holeNumber
      const hole = holes[hn]
      divs.push(<div key={uniqueKey(holeProp, r, holeNumber)}
        onClick={(function (hn) {
          return () => { allowMods && holeProp && handleHoleNumber(holeProp, hn); };
        })(holeNumber)}
      >
        {holeProp ? hole[holeProp] : holeNumber}</div>)
    }
  }

  const teeBoxDiv = (name, rating, slope) => <div>
    <div>{name}</div>
    <div>
      <div>{rating}{'/'}{slope}</div>
    </div>
  </div>

  const yardageDivs = (s, e, divs, r, holeProp, teeBox) => {
    const { rating, slope } = teeBox
    divs.push(<div key={uniqueKey('sc', holeProp, r, 'r')} className={'sct'} >{teeBoxDiv(_.startCase(holeProp), rating, slope)}</div>)
    for (var holeNumber = s; holeNumber <= e; ++holeNumber) {
      const hn = holeNumber
      const hole = holes[hn]
      const tb = hole[holeProp]
      divs.push(<div key={uniqueKey('sc', 'r', holeProp, r, holeNumber)}
        onClick={(function (hn) {
          return () => { allowMods && holeProp && handleHoleNumber(holeProp, hn); };
        })(holeNumber)}
      >
        {tb}</div>)
    }
  }

  const holePrizeDivs = (s, e, divs, r, prize, cn) => {
    let _cn = cn
    if (r === 2) { _cn += ' bn' }
    divs.push(<div key={uniqueKey('sc', prize, r, 'p')} className={'sct'} >{_.startCase(prize)}</div>)
    for (var holeNumber = s; holeNumber <= e; ++holeNumber) {
      const hn = holeNumber
      const text = holePrizes && holePrizes[prize] && holePrizes[prize].includes(hn) ? 'Y' : '-'
      divs.push(<div key={uniqueKey('sc', prize, r, holeNumber)} className={_cn} onClick={() => { allowMods && handleHolePrizes(hn, prize) }}>{text}</div>)
    }
  }

  const sc = () => {
    const divs = []
    // loop each 9
    for (var r = 1; r <= 2; ++r) {
      const start = r === 1 ? 1 : 10
      const end = r === 1 ? 9 : 18
      holeDivs(start, end, divs, r, 'xxx', null)
      holeDivs(start, end, divs, r, 'par')
      holeDivs(start, end, divs, r, 'handicap')
      if (teeBoxes) {
        Object.keys(teeBoxes).forEach(key => {
          const teeBox = teeBoxes[key]
          yardageDivs(start, end, divs, r, key, teeBox)
        })
      }
      switch (scorecardType) {
        case scorecardTypes.scoring:
          holePrizeDivs(start, end, divs, r, 'closestToPin', 'c2p')
          holePrizeDivs(start, end, divs, r, 'longestDrive', 'ld')
          break;
        default:
        // nothing
      }
      // holeTees(s, e, divs, r)
    }
    return divs
  }

  const ims_teeBoxes = () => {
    const oc = (item) => setSelectedTeeBox(item)
    const fnStyle = (item) => {
      return { ...getSplitColorStyles({ backgroundColor: item.name }) }
    }
    return <ItemMenuSquares
      menuItems={_.sortBy(teeBoxes, 'rating')}
      imsType={_imsTypes.menu}
      iconItem={'flag outline'}
      activeItem={selectedTeeBox?.name}
      ignoreStartCase={true}
      fn_style={fnStyle}
      onClick={oc}
    />
  }

  const ims_golfCourse = () => {
    const fnAlt = (item) => {
      if (selectedTeeBox) {
        const { par, handicap } = item
        const other = `_${selectedTeeBox?.name}`
        const otherItem = item?.[other]
        return <div style={{ display: 'flex', alignItems: 'center' }}>
          {otherItem && <Label size='tiny' style={getSplitColorStyles({ backgroundColor: otherItem })}>{otherItem}</Label>}
          <Label size='tiny' color='blue'>{`Par: ${par}`}</Label>
          <Label size='tiny' color='green'>{`HCP: ${handicap}`}</Label>
          <Label size='tiny' color='black'>{`YARDAGE: ${item?.[selectedTeeBox?.name]}`}</Label>
        </div>
      }
    }
    const h_gc = () => {
      const { name, rating, slope } = selectedTeeBox ?? {}
      return <div style={{
        display: 'flex',
        alignItems: 'center',
        textAlign: 'center',
        justifyContent: 'center',
      }}>
        <Label size='tiny' style={getSplitColorStyles({ backgroundColor: name })}>{name}</Label>
        <Label size='tiny' color='blue'>{rating && `Rating: ${rating}`}</Label>
        <Label size='tiny' color='green'>{slope && `Slope: ${slope}`}</Label>
        <Label size='tiny' color='black'>{slope && `Distance: ${teeboxDistance}`}</Label>
      </div >
    }

    return <Wrapper
      header={h_gc()}
      content={<ItemMenuSquares
        menuItems={holes}
        imsType={_imsTypes.inline}
        iconItem={'flag'}
        fn_altContent={fnAlt}
      />}
      wrapperType={wrapperTypes.padded}
    ></Wrapper>
  }

  const content_golfCourse = () => <Wrapper
    header={_golfCourse?.name}
    search={ims_teeBoxes()}
    content={selectedTeeBox && ims_golfCourse()}
    wrapperType={wrapperTypes.padded}
  ></Wrapper>

  const content = () => <div className={'golf-page-container'}>
    <div className={'golf-container golf-header'}>
      <div className={'scorecard-content'}>
        <div className={'golf-match-holes title'}>
          {holes && sc()}
        </div>
      </div>
    </div>
  </div>

  const form_hole = (holeProp, holeData) => {
    const appFormItems = {
      [holeProp]: settingsHelpers.newPropEditItem(holeProp, gEnums.formItemTypes.text)
    }
    return <AppForm
      appFormItems={appFormItems}
      handleSave={handleUpdateHoleData}
      data_parent={holeData}
    />
  }

  const editHole = () => {
    const { holeProp, holeNumber } = selectedHole ?? {}
    const _hole = holes ? holes[holeNumber] : {}
    const _teebox = teeBoxes ? teeBoxes[holeProp] : {}
    const { par, handicap } = _hole ?? {}
    let _value;
    switch (holeProp) {
      case 'par':
        _value = par
        break;
      case 'handicap':
        _value = handicap
        break;
      default:
        _value = _hole[holeProp]
    }
    const holeData = {
      [holeProp]: _value
    }
    return <Segment inverted>
      <Header>{'Hole: ' + holeNumber}{': '}{_.startCase(holeProp)}</Header>
      {form_hole(holeProp, holeData)}
    </Segment>
  }

  const sidebar_left = (visible) => <DataSidebar direction={'bottom'} visible={visible} content={visible && editHole()} onHide={handleCloseHoleEdit} />

  const sidebar = () => <Sidebar.Pushable style={{ overflow: 'hidden' }}>
    {sidebar_left(selectedHole ? true : false)}
    <Sidebar.Pusher dimmed={selectedHole ? true : false} className={'h100'}>
      {content_golfCourse()}
    </Sidebar.Pusher>
  </Sidebar.Pushable>

  return sidebar()

}

export default Scorecard
